import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Search } from '@/components/base/search';
import { Tag } from '@/components/ui/tag';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { BackButton } from '../back-button';
import { Channels } from './channels';
import { Sort, SortBy } from './sort';

export function SelectChannels() {
  const intl = useIntl();
  const { selectedChannelSlugs } = useJobPostingContext();

  const [searchQuery, setSearchQuery] = useState<string>();
  const [sortBy, setSortBy] = useState<SortBy>();

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col gap-3 overflow-hidden">
      <div className="flex items-center justify-between pr-4">
        <BackButton />
        <Tag
          text={
            <Typography variant="subtitle1" className="!text-fx-neutral-900">
              <FormattedMessage
                defaultMessage="{count} channels selected"
                description="Count of channels selected"
                values={{ count: selectedChannelSlugs.length }}
              />
            </Typography>
          }
          className="bg-fx-brand-50"
        />
      </div>

      {/* Title and search input */}
      <div className="flex items-center justify-between px-4">
        <Typography variant="h4">
          <FormattedMessage
            defaultMessage="Available boards"
            description="Job boards available for posting campaigns"
          />
        </Typography>
        <div className="flex items-center gap-2">
          <Sort sortBy={sortBy} setSortBy={setSortBy} />
          <Search
            setSearchQuery={setSearchQuery}
            placeholder={intl.formatMessage({
              defaultMessage: 'Search 2,000+ channels',
              description: 'Placeholder for the search input',
            })}
            className="w-[200px]"
          />
        </div>
      </div>

      {/* Channels list */}
      <Channels searchQuery={searchQuery} sortBy={sortBy} />
    </div>
  );
}
